import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

type Props = {
  text?: string;
  classOverride?: string;
};

const ChipSkeleton = (props: Props) => {
  const { text = 'NA', classOverride = '' } = props;

  return (
    <div
      className={twMerge(
        classNames(
          'w-20 h-6 bg-surface-skeleton rounded-lg animate-pulse text-text-secondary text-sm flex items-center justify-center',
          classOverride,
        ),
      )}
    >
      {text}
    </div>
  );
};

export default ChipSkeleton;
